<div class="top">
  <h3 class="header">
    {{ 'other-products.other-products' | translate }}
  </h3>

  <app-tab-group tabJustify="end"
    class="no-margin"
    containerSize="large"
    >
    @if (related.strategy !== RelatedProductsStrategy.none && related.products.length > 0) {
      <app-tab [label]="'other-products.related' | translate"
        [value]="Categories.RELATED"
        >
        <div class="grid-container">
          <app-related-products-hits [products]="related.products" />
        </div>
        @if (related.products.length >= relatedLimit) {
          <div class="bottom">
            <app-button theme="line"
              (click)="loadMoreProducts(OtherProductsCategories.RELATED)"
              >
              {{ 'products.show-more-products' | translate }}
            </app-button>
          </div>
        }
      </app-tab>
    }

    @if (lastViewed.length > 0) {
      <app-tab [label]="'other-products.last-viewed' | translate"
        [value]="Categories.RECENT"
        >
        <div class="grid-container">
          <app-related-products-hits [products]="lastViewed" />
        </div>
        @if (lastViewed.length >= lastViewedLimit) {
          <div class="bottom">
            <app-button theme="line"
              (click)="loadMoreProducts(OtherProductsCategories.RECENT)"
              >
              {{ 'products.show-more-products' | translate }}
            </app-button>
          </div>
        }
      </app-tab>
    }

    @if (sameSeries.length > 0) {
      <app-tab [label]="'other-products.same-series' | translate"
        [value]="Categories.SAME_SERIES"
        >
        <div class="grid-container">
          <app-related-products-hits [products]="sameSeries" />
        </div>
        @if (sameSeries.length >= sameSeriesLimit) {
          <div class="bottom">
            <app-button theme="line"
              (click)="loadMoreProducts(OtherProductsCategories.SAME_SERIES)"
              >
              {{ 'products.show-more-products' | translate }}
            </app-button>
          </div>
        }
      </app-tab>
    }

    @if (sameBrand.length > 0) {
      <app-tab [label]="'other-products.same-brand' | translate"
        [value]="Categories.SAME_BRAND"
        >
        <div class="grid-container">
          <app-related-products-hits [products]="sameBrand" />
        </div>
        @if (sameBrand.length >= sameBrandLimit) {
          <div class="bottom">
            <app-button theme="line"
              (click)="loadMoreProducts(OtherProductsCategories.SAME_BRAND)"
              >
              {{ 'products.show-more-products' | translate }}
            </app-button>
          </div>
        }
      </app-tab>
    }
  </app-tab-group>
</div>
